<h2 mat-dialog-title>{{ 'dialog.add_activity_improved.title' | translate }}</h2>
<mat-dialog-content class="activity-improved-dialog-content">
  <div class="improved-activities-container">
    @for (activity of improvedActivities; track activity; let i = $index) {
      <div class="activity-row">
        <span class="activity-name">{{ activity.organization_unit_name }}</span>
        <span class="activity-date">{{ activity.show_until | i18n_date | async }}</span>
        <button mat-icon-button color="warn" (click)="removeActivityImproved(activity.organization_unit_id)" aria-label="Delete activity">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'dialog.add_activity_improved.show_until' | translate }}</mat-label>
    <input matInput [formControl]="showUntil" [matDatepicker]="picker" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="closeDialog()">{{ 'generic.cancel' | translate | uppercase }}</button>
  <button mat-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'generic.save' | translate }}</button>
</mat-dialog-actions>
